import React from 'react'
import { Redirect } from 'react-router-dom'

import { Routes } from '../../navigation/config/routes'

/**
 * Signable Docs library lives in Contract Manager → Documents.
 * Keep this route so old bookmarks land on the Documents tab.
 */
export const SignableDocsHome: React.FC = () => (
    <Redirect to={`${Routes.manage.contractManager}?tab=documents`} />
)
